import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectModule, selectLoading, selectLoaded } from '../selectors/module.selector';
import { moduleActions } from '../actions/module.actions';

@Injectable({
    providedIn: 'root',
})
export class ModuleFacade {
    private store = inject(Store);

    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));
    readonly module$ = (id: string) => this.store.select(selectModule(id));
    readonly moduleNonNullable$ = (id: string) => this.store.select(selectModule(id)).pipe(filter((data) => data !== null));

    getModule(id: string) {
        this.store.dispatch(moduleActions.getModule({ id }));
    }

    clear() {
        this.store.dispatch(moduleActions.clear());
    }
}
